import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from 'antd';
import { useAuthStore } from './stores/authStore';
import LoginPage from './pages/login/LoginPage';
import FamiliesMobile from './pages/families/FamiliesMobile';
import SystemInfoPage from './pages/system/SystemInfoPage';
import ExpensesCategoriesPageWrapper from './pages/expenses/ExpensesCategoriesPageWrraper';
import { ExpenseReportPage } from './pages/expenses/ExpenseReportPage';
import ExpensesPageWrapper from './pages/expenses/ExpensesPageWrraper';
import GiftsDashboardPage from './pages/gifts/GiftsDashboardPage';
import EventsPage from './pages/gifts/EventsPage';
import GiftGiversPage from './pages/gifts/GiftGiversPage';
import GiftsPage from './pages/gifts/GiftsPage';
import AppLayout from './components/common/AppLayout';
import './App.css';


const { Content } = Layout;

const App = React.memo(() => {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <AppLayout>
      <Content style={{ padding: '0', height: '100%' }}>
        <Routes>
          <Route path="/" element={<Navigate to="/families" replace />} />
          <Route path="/families" element={<FamiliesMobile />} />
          <Route path="/system" element={<SystemInfoPage />} />
          <Route path="/expenses" element={<ExpensesPageWrapper />} />
          <Route path="/expenses/categories" element={<ExpensesCategoriesPageWrapper />} />
          <Route path="/expenses/reports" element={<ExpenseReportPage />} />
          <Route path="/gifts" element={<GiftsDashboardPage />} />
          <Route path="/gifts/events" element={<EventsPage />} />
          <Route path="/gifts/givers" element={<GiftGiversPage />} />
          <Route path="/gifts/list" element={<GiftsPage />} />
        </Routes>
      </Content>
    </AppLayout>
  );
});

App.displayName = 'App';

export default App; 